export default __webpack_public_path__ + "static/love-it-stamp@2x-2e98ad93b360da8f0978f207147ef5d7.png";